export default {
  data: () => ({
    categories: [
      'Rundbahn',
      'Stabhochsprung',
      'Hauptfeld',
      'Weitsprung',
      'Hochsprung',
    ],
    categoryList: [
      {text: 'Gesamte Anlage', value: [0, 1, 2, 3, 4]},
      {text: 'Rundbahn', value: 0},
      {text: 'Stabhochsprung', value: 1},
      {text: 'Hauptfeld', value: 2},
      {text: 'Weitsprung', value: 3},
      {text: 'Hochsprung', value: 4},
    ]
  }),
}
